import { useSelector } from "react-redux"

export function Dayformat (date) {
    return new Date(`${date}`).toLocaleString('en',{day:'2-digit'})
}
export function Monthformat (date) {
    return new Date(`${date}`).toLocaleString('en',{month:'2-digit'})
}
export function Shortmonthformat (date) {
    return new Date(`${date}`).toLocaleString('en',{month:'short'})
}
export function Longmonthformat (date) {
    return new Date(`${date}`).toLocaleString('en',{month:'long'})
}
export function Yearformat (date) {
    return new Date(`${date}`).toLocaleString('en',{year:'numeric'})
}
export function Timeformat (date) {
   return new Date(date).toLocaleString('en', {
        hour12:true,
        hour: '2-digit',
        minute: 'numeric',
    })
}
export function Timeformat24hours (date) {
    return new Date(date).toLocaleString('en', {
        hour12:false,
        hour: '2-digit',
        minute: 'numeric',
    })
}

export function Day ({date}) {
    const language = useSelector((state)=>state?.languageState?.language)

    return new Date(`${date}`).toLocaleString(language.toLowerCase(),{day:'2-digit'})
}
export function Month ({date}) {
      const language = useSelector((state)=>state?.languageState?.language)

    return new Date(`${date}`).toLocaleString(language.toLowerCase(),{month:'2-digit'})
}
export function ShortMonth ({date}) {
    const language = useSelector((state)=>state?.languageState?.language)

    return new Date(`${date}`).toLocaleString(language.toLowerCase(),{month:'short'})
}
export function LongMonth ({date}) {
    const language = useSelector((state)=>state?.languageState?.language)

    return new Date(`${date}`).toLocaleString(language.toLowerCase(),{month:'long'})
}
export function Year ({date}) {
    const language = useSelector((state)=>state?.languageState?.language)

    return new Date(`${date}`).toLocaleString(language.toLowerCase(),{year:'numeric'})
}
export function Time ({date}) {
    const language = useSelector((state)=>state?.languageState?.language)

   return new Date(date).toLocaleString(language.toLowerCase(), {
        hour12:true,
        hour: '2-digit',
        minute: 'numeric',
    })
}
export function Time24hours ({date}) {
  const language = useSelector((state)=>state?.languageState?.language)

    return new Date(date).toLocaleString(language.toLowerCase(), {
        hour12:false,
        hour: '2-digit',
        minute: 'numeric',
    })
}